import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader,
} from '@coreui/react';

import { apiClient } from 'services/Api';
import { jwtDecode } from 'jwt-decode';
import DataTableComponent from "components/DataTableComponent";
import ToastNotification from 'components/globals/ToastNotification';
import AlertNotification, { triggerAlert } from 'components/globals/AlertNotification';
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";

const UserList = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [users, setUsers] = useState([]);
    const [toast, setToast] = useState(null);
    const [previewUser, setPreviewUser] = useState(null);
    const token = localStorage.getItem("access_token");
    const decodedToken = jwtDecode(token);
    const is_director = decodedToken.is_director;
    const isStaff = decodedToken.is_staff;
    const user_id = decodedToken.user_id;

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await apiClient.get(`/users/`);
                setUsers(response.data);
                setPreviewUser((current) => current
                    ? response.data.find((user) => user.id === current.id) || null
                    : null);
            } catch (error) {
                console.error('Error fetching users:', error);
            }
        };

        fetchUsers();
    }, [id, location.pathname]);


    const handleDeactivate = async (userId) => {
        try {
            await apiClient.delete(`/users/${userId}/`);
            triggerAlert("Utilizador desativado com sucesso!", "success");
            navigate("/utilizadores");
        } catch (error) {
            const errorMessage = error.response?.data?.error || "Erro ao desativar utilizador";
            setToast({ title: 'Utilizador', message: errorMessage, type: "error" });
            console.error("Error deactivating user:", error);
        }
    };

    const columns = [
        { name: "Nome", selector: (row) => `${row.first_name} ${row.last_name}`, sortable: true },
        { name: "Email", selector: (row) => row.email, sortable: true },
        { name: "Estado", selector: (row) => row.is_active ? "Ativo" : "Inativo", sortable: true },
    ];

    return (
        <>
            <ToastNotification toast={toast} setToast={setToast} />
            <AlertNotification />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Utilizadores</h3>
                    <Link to="/utilizadores/new">
                        <CButton color="info" className="text-white">Novo Utilizador</CButton>
                    </Link>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent
                        columns={columns}
                        data={users}
                        onRowClicked={setPreviewUser}
                    />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewUser}
                onHide={() => setPreviewUser(null)}
                title="Utilizador"
                subtitle={previewUser ? `${previewUser.first_name} ${previewUser.last_name}` : null}
                fields={previewUser ? [
                    { label: "Nome", value: `${previewUser.first_name} ${previewUser.last_name}` },
                    { label: "Email", value: previewUser.email },
                    { label: "Estado", value: previewUser.is_active ? "Ativo" : "Inativo" },
                ] : []}
                headerActions={previewUser && (user_id === previewUser.id || is_director || isStaff) && <>
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/utilizadores/${previewUser.id}`)}>
                        Editar
                    </CButton>
                    {user_id !== previewUser.id && previewUser.is_active && (is_director || isStaff) && (
                        <CButton color="danger" size="sm" className="text-white" onClick={() => {
                            if (window.confirm("Tem a certeza que quer desativar este utilizador?")) handleDeactivate(previewUser.id);
                        }}>
                            Desativar
                        </CButton>
                    )}
                </>}
            />
        </>
    );

}

export default UserList;
